import { useDraggable } from "@dnd-kit/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import { DragHandleIcon } from "../../icons";
import { DragHandleProps, PlannerAutomation } from "./journeyPlanner.types";
import AutomationStatusBadge from "./AutomationStatusBadge";

function SidebarAutomationCardContent({
  automation,
  dragHandleAttributes,
  dragHandleListeners,
  dragHandleRef,
  showDragHandle = true,
}: DragHandleProps & {
  automation: PlannerAutomation;
  showDragHandle?: boolean;
}) {
  return (
    <div className="bg-white border rounded-2 py-3 pe-3 ps-2">
      <div className="d-flex justify-content-between align-items-start gap-3">
        {showDragHandle && (
          <div
            className="drag-handle d-inline-flex align-items-center justify-content-center flex-shrink-0 fs-6"
            ref={dragHandleRef}
            title="Move automation"
            {...dragHandleAttributes}
            {...dragHandleListeners}
          >
            <FontAwesomeIcon icon={DragHandleIcon} />
          </div>
        )}
        <div className="flex-grow-1">
          <strong>{automation.Name}</strong>
          {automation.CommunicationName && (
            <div className="small text-muted">
              {automation.CommunicationName}
            </div>
          )}
        </div>
        <AutomationStatusBadge status={automation.Status} />
      </div>
    </div>
  );
}

function SidebarAutomationCard({
  automation,
  className,
  draggable = true,
}: {
  automation: PlannerAutomation;
  className?: string;
  draggable?: boolean;
}) {
  const {
    attributes,
    listeners,
    setActivatorNodeRef,
    setNodeRef,
    transform,
  } =
    useDraggable({
      disabled: !draggable,
      id: `sidebar-automation-${automation.Id}`,
      data: {
        type: "sidebar-automation",
        automation,
        automationId: automation.Id,
        label: automation.Name,
        name: automation.Name,
      },
    });

  const style =
    draggable && transform
      ? {
          transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
        }
      : undefined;

  return (
    <div
      className={classNames("mb-3", className)}
      ref={draggable ? setNodeRef : undefined}
      style={style}
    >
      <SidebarAutomationCardContent
        automation={automation}
        dragHandleAttributes={draggable ? attributes : undefined}
        dragHandleListeners={draggable ? listeners : undefined}
        dragHandleRef={draggable ? setActivatorNodeRef : undefined}
      />
    </div>
  );
}

export { SidebarAutomationCardContent };
export default SidebarAutomationCard;
